import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { signupUrl } from '../../lib/env';
import { AccentBar } from '../layout/accent-bar';
import { Container } from '../layout/container';

import { BrowserFrame, MiniTimer } from './device-frames';

export function HeroSection() {
  const { t } = useTranslation('marketing');

  return (
    <section className="border-b border-border py-16 md:py-24">
      <Container className="grid items-center gap-12 md:grid-cols-2">
        <div>
          <AccentBar className="animate-rise-in mb-6" />
          <h1
            className="animate-rise-in text-hero text-ink"
            style={{ animationDelay: '60ms' }}
          >
            {t('home.hero.headline')}
          </h1>
          <p
            className="animate-rise-in mt-6 max-w-[60ch] text-body text-muted"
            style={{ animationDelay: '90ms' }}
          >
            {t('home.hero.body')}
          </p>
          <div
            className="animate-rise-in mt-8 flex flex-col gap-3 sm:flex-row"
            style={{ animationDelay: '160ms' }}
          >
            <Button size="lg" asChild>
              <a href={signupUrl}>{t('home.hero.ctaStart')}</a>
            </Button>
            <Button size="lg" variant="secondary" asChild>
              <Link to="/features">{t('home.hero.ctaSecondary')}</Link>
            </Button>
          </div>
          <p
            className="animate-rise-in mt-6 text-label text-muted"
            style={{ animationDelay: '220ms' }}
          >
            {t('home.hero.note')}
          </p>
        </div>

        <div className="animate-rise-in" style={{ animationDelay: '120ms' }}>
          <BrowserFrame className="mx-auto max-w-sm">
            <MiniTimer project={t('home.hero.demo.project')} time={t('home.hero.demo.time')} active />
            <div className="mt-4 space-y-2 border-t border-border pt-4">
              <div className="flex items-center justify-between text-body">
                <span className="text-ink">{t('home.hero.demo.today')}</span>
                <span className="font-mono tabular-nums text-muted">{t('home.hero.demo.todayTotal')}</span>
              </div>
              <div className="flex items-center justify-between text-body">
                <span className="text-ink">{t('home.hero.demo.thisWeek')}</span>
                <span className="font-mono tabular-nums text-muted">{t('home.hero.demo.thisWeekTotal')}</span>
              </div>
            </div>
          </BrowserFrame>
          <p className="mx-auto mt-5 max-w-sm text-center font-mono text-label uppercase tracking-[0.18em] text-muted">
            Web&nbsp;·&nbsp;iOS&nbsp;·&nbsp;Android&nbsp;·&nbsp;Desktop
          </p>
        </div>
      </Container>
    </section>
  );
}
